import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { getBIDSTencentQCouldMassage } from '@sg/services/cos';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';

interface BoardGovernanceDocPreviewerProps extends IBaseProps {
  doc_key: string;
  doc_name?: string;
  doc_suffix?: string;
  cos_domain?: string;
}

const getAuth = async (): Promise<boolean> => !!sessionStorage.getItem('userName');

const BoardGovernanceDocPreviewer: React.FC<BoardGovernanceDocPreviewerProps> = ({
  style,
  className,
  doc_key: docKey,
  doc_name: docName = '',
  doc_suffix: docSuffix = '',
  cos_domain: cosDomain,
}) => {
  const cosPath = cosDomain || 'mgmt/board_governance';
  const useAccelerate = ['pre', 'pro'].includes(ENV);

  return (
    <div style={style} className={classnames('dbs-board-governance-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(cosPath),
          authorizationFetcher: () => getBIDSTencentQCouldMassage(cosPath),
        }}
        getAuthParams={{}}
        getAuth={getAuth}
        toolbar={
          <NavigatorToolbar
            title="Back to Board Governance"
            onNavigatorClick={() => history.replace('/strategic/home?tab=studio&subtitle=boardGovernance')}
          />
        }
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default BoardGovernanceDocPreviewer;
